import React from 'react';

// Mobile (APK) Invite Forms — stacked cards, full-width upload button.
export default function InviteFormsMobile({ vm }) {
  const { allowed, hasEvent, eventTitle, slots, pick, upload } = vm;

  if (!allowed || !hasEvent) {
    return (
      <div>
        <div className="page-head"><h1>Invite Forms</h1></div>
        <div className="card card-pad empty">
          {!allowed ? 'You do not have access to invite forms.' : 'Select an event before uploading invite forms.'}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Invite Forms</h1>
        <span className="muted">{eventTitle}</span>
      </div>
      <div className="mobile-card-list">
        {slots.map(slot => (
          <div key={slot.kind} className="card card-pad mobile-record-card">
            <div className="mobile-card-head" style={{ alignItems: 'baseline' }}>
              <strong className="mobile-title">{slot.title}</strong>
              <div style={{ flex: 1 }} />
              <span className={slot.media?.url ? 'chip ok' : 'chip pend'}>{slot.media?.url ? 'Ready' : 'Not set'}</span>
            </div>
            <label className="field">Upload file
              <input type="file" accept={slot.accept} disabled={slot.busy} onChange={e => pick(slot.kind, e.target.files?.[0])} />
            </label>
            {slot.picked && <div className="muted" style={{ fontSize: 13 }}>{slot.picked.name}</div>}
            {slot.media?.url && (
              <div className="mobile-meta">
                <div className="muted">Current file: {slot.media.name || slot.media.url}</div>
                <a href={slot.media.url} target="_blank" rel="noreferrer">Open uploaded file</a>
              </div>
            )}
            <div className="mobile-actions">
              <button type="button" className="btn primary" style={{ width: '100%', padding: 12 }} disabled={slot.busy || !slot.picked} onClick={() => upload(slot.kind)}>
                {slot.busy ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
